export { default as GDMLanguageSwitcher } from './GDMLanguageSwitcher';

export type { GDMLanguageSwitcherComponent } from './GDMLanguageSwitcher.type';
